export default "__VITE_ASSET__CIS3$4Uk__"